import { sgg } from 'ml-savitzky-golay-generalized';
/**
 * Calculate the second derivative using Savitzky–Golay filter.
 * @param data
 * @param options
 */
export function secondDerivative(data, options = {}) {
    const { x, y } = data;
    return { data: { x, y: sgg(y, x, { ...options, derivative: 2 }) } };
}
//# sourceMappingURL=secondDerivative.js.map